import { useEffect } from "react";
import { createPortal } from "react-dom";

import { useClipQualitySettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";
import { ClipQualitySettingsModal } from "./index";

const MODAL_QUERY_PARAM = "clip-quality-settings";

export const ClipQualitySettingsModalRenderer = () => {
  const { isOpen, open, close } = useClipQualitySettingsModal();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has(MODAL_QUERY_PARAM)) {
      open();

      params.delete(MODAL_QUERY_PARAM);
      const remaining = params.toString();
      const newUrl =
        window.location.pathname + (remaining ? `?${remaining}` : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isOpen) return null;

  return createPortal(
    <ClipQualitySettingsModal onClose={close} />,
    document.getElementById("root") || document.body,
  );
};
